import { render, staticRenderFns } from "./answers.vue?vue&type=template&id=259ab5a7&scoped=true"
import script from "./answers.vue?vue&type=script&lang=js"
export * from "./answers.vue?vue&type=script&lang=js"
import style0 from "./answers.vue?vue&type=style&index=0&id=259ab5a7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259ab5a7",
  null
  
)

export default component.exports